<!--  -->
<template>
  <div class="select_box">
    <div class="select_box_title">数据年份：</div>
    <el-select
      size="small"
      v-model="yearValue"
      placeholder="请选择"
      @change="changeYear"
    >
      <el-option
        v-for="item in yearOptions"
        :key="item.value"
        :label="item.label"
        :value="item.value"
      >
      </el-option>
    </el-select>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    defaultValue: {
      type: String | Number,
      default: function() {
        return '2023'
      }
    },
    yearOptions: {
      type: Array,
      default: function() {
        return [
          {
            value: '2023',
            label: '2023年'
          },
          {
            value: '2022',
            label: '2022年'
          }
        ]
      }
    }
  },
  data() {
    return {
      yearValue: ''
    }
  },
  computed: {},
  methods: {
    changeYear() {
      this.$emit('changeYear', this.yearValue)
    }
  },
  created() {},
  mounted() {},
  watch: {
    defaultValue: {
      immediate: true,
      deep: true,
      handler: function(newValue, oldValue) {
        this.$nextTick(() => {
          this.yearValue = newValue
        })
      }
    }
  }
}
</script>
<style lang="less" scoped>
/* 年份搜索框 */
.select_box {
  display: flex;
  font-size: 13px;
  align-items: center;
  font-family: 'Microsoft Yahei', sans-serif;
  .el-select {
    width: 100px;
    /deep/.el-input--small .el-input__inner {
      height: 24px;
      line-height: 24px;
      border: none;
      background: transparent;
    }
    /deep/.el-input--small .el-input__icon {
      line-height: 24px;
    }
  }
}
</style>
